import { Outlet, NavLink } from 'react-router-dom'
import {
    MdPerson,
    MdGroup,
    MdHistory,
    MdPayment,
    MdPayments,
    MdLock,
    MdDescription,
} from 'react-icons/md'

import './Settings.css'

const links = [
    { Icon: MdPerson, path: '/settings', title: 'Personal Info', props: { end: true } },
    { Icon: MdGroup, path: '/settings/orgs', title: 'Organizations' },
    { Icon: MdHistory, path: '/settings/history', title: 'History' },
    { Icon: MdPayment, path: '/settings/billing', title: 'Billing' },
    { Icon: MdPayments, path: '/settings/purchases', title: 'Purchases' },
]

export const Settings = () => {
    
    return (
        
        <div className="Settings">
            
            <div className="shrink-0">
                
                <ul className="menu bg-base-200/30 w-56 rounded-md mt-5 ml-2">
                    {links.map(it => (
                        <li key={it.path} className="list-group-item">
                            <NavLink
                                className={({ isActive }) => isActive ? 'active' : ''}
                                to={it.path}
                                {...(it.props ?? {})}>
                                <it.Icon className="text-xl" />
                                {it.title}
                            </NavLink>
                        </li>
                    ))}
                    <li className="list-group-item mt-4">
                        <a
                            title="Privacy Policy"
                            href="https://www.iubenda.com/privacy-policy/58341280"
                            rel="noreferrer"
                            target="_blank">
                            <MdLock className="text-xl" />
                            Privacy Policy
                        </a>
                    </li>
                    <li className="list-group-item">
                        <a
                            title="Terms and Conditions"
                            href="https://www.iubenda.com/terms-and-conditions/58341280"
                            rel="noreferrer"
                            target="_blank">
                            <MdDescription className="text-xl" />
                            Terms and Conditions
                        </a>
                    </li>
                </ul>
            </div>
            
            <div className="flex flex-col w-full">
                <Outlet />
            </div>
        
        </div>
        
    )
    
}
